import { Button, DataHeader, DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderType extends Layout {
    buttonClearEvenColor: Button;
    buttonColorPicker: Button;
    buttonOpenClassic: Button;
    labelOrderPlanningColor: Label;
    panelColorDisplay: Panel;
    panelColorSelector: Panel;
    panelDataHeader: DataHeader;
    panelDataHeaderAddlLeft: Panel;
    panelOrderType: Panel;
    sourceOrderType: DataSource;
    switchIsActive: Switch;
    textOrderType: Textbox;
    textboxDescr: Textbox;
    textboxHexPlanningColor: Textbox;
    textboxOrderMode: Textbox;
    textboxPlanningColor: Textbox;
}
